import { render, staticRenderFns } from "./QuestionTask.vue?vue&type=template&id=f8309a7a&scoped=true"
import script from "./QuestionTask.vue?vue&type=script&lang=js"
export * from "./QuestionTask.vue?vue&type=script&lang=js"
import style0 from "./QuestionTask.vue?vue&type=style&index=0&id=f8309a7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8309a7a",
  null
  
)

export default component.exports